import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    height: 496px;
    background: url(${props => props.srcPath}) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    border-radius: 9px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;
export const Text = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.white};
    padding: 5px 20px;
    width: 100%;
`;
export const ButtonContainer = styled.div`
    padding: 20px;
    width: 100%;
    @media (max-width: 1279px) {
        width: 100%;
    }
`;
export const Button = styled(StyledButton)`
    padding: 10px 17px;
`;
